import React, { useEffect, useState } from "react";
import { Mail, MessageCircle, FileText, FileSpreadsheet, Clock } from "lucide-react";
import api, { trDate } from "@/lib/api";
import { Card } from "@/components/Cards";

const CH = {
  email: { icon: Mail, label: "E-posta", color: "text-sky-400" },
  whatsapp: { icon: MessageCircle, label: "WhatsApp", color: "text-emerald-500" },
  pdf: { icon: FileText, label: "PDF indirildi", color: "text-rose-400" },
  xlsx: { icon: FileSpreadsheet, label: "Excel indirildi", color: "text-emerald-400" },
};

const period = (s) => (s.date_from || s.date_to ? `${s.date_from ? trDate(s.date_from) : "…"} – ${s.date_to ? trDate(s.date_to) : "…"}` : "Tüm hareketler");

export default function ShareHistory({ customerId, refreshKey }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!customerId) return;
    api.get(`/ledger/statement/${customerId}/share-log`).then((r) => setRows(r.data));
  }, [customerId, refreshKey]);

  return (
    <Card className="p-4" data-testid="share-history">
      <div className="flex items-center gap-2 mb-3">
        <Clock className="h-4 w-4 text-muted-foreground" />
        <h3 className="font-heading font-semibold text-sm">Gönderim Geçmişi</h3>
        <span className="text-xs text-muted-foreground">({rows.length})</span>
      </div>
      {rows.length === 0 ? (
        <div className="text-xs text-muted-foreground py-4 text-center" data-testid="share-history-empty">Bu müşteriye henüz ekstre gönderilmedi</div>
      ) : (
        <div className="max-h-56 overflow-y-auto divide-y divide-border/60">
          {rows.map((s) => {
            const m = CH[s.channel] || CH.pdf;
            const Icon = m.icon;
            return (
              <div key={s.id} data-testid={`share-history-row-${s.id}`} className="flex items-center gap-3 py-2 text-xs">
                <Icon className={`h-4 w-4 shrink-0 ${m.color}`} />
                <div className="min-w-0 flex-1">
                  <div className="font-medium">
                    {m.label}
                    {(s.channel === "email" || s.channel === "whatsapp") && s.to && <span className="text-muted-foreground font-normal"> → {s.to}</span>}
                  </div>
                  <div className="text-muted-foreground">Dönem: {period(s)}{s.sent_by && <> · {s.sent_by}</>}</div>
                </div>
                <div className="font-mono text-muted-foreground whitespace-nowrap">
                  {new Date(s.created_at).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
